import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { myRoutes, Route } from './routes';
import { AppState } from '../store/app.reducer';

export const privateGuard: CanActivateFn = (route, state) => {
  return validateUrl(state.url);
};

export const privateChildGuard: CanActivateChildFn = (route, state) => {
  return validateUrl(state.url);
};

function validateUrl(url: string): boolean | UrlTree {
  const router = inject(Router);
  const state: AppState = localStorage.getItem('appState') ? JSON.parse(atob(localStorage.getItem('appState')!)) : null;
  const { auth, project } = state;
  if (!auth?.user) {
    return router.parseUrl('/auth/login');
  }

  let routes: Route[];
  if (project.project.projectId === -1 && !project.project.allClient) {
    routes = myRoutes.adminNotProyect;
  } else {
    const modules: string[] = JSON.parse(atob(localStorage.getItem('routes') || ''));
    return modules.some((item) => url.includes(item)) || router.parseUrl('/auth/login');
  }

  const routeFound = routes.find((r) => r.route && url.includes(r.route));
  return routeFound !== undefined || router.parseUrl('/auth/login');
}